export const Target = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8279 11.1722C13.6477 11.9921 13.6477 13.3213 12.8279 14.1411C12.0081 14.9609 10.6788 14.9609 9.85901 14.1411C9.03918 13.3213 9.03918 11.9921 9.85901 11.1722C10.6788 10.3524 12.0081 10.3524 12.8279 11.1722Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M15.3478 8.65194C17.5595 10.8637 17.5595 14.4496 15.3478 16.6613C13.1361 18.873 9.55017 18.873 7.33845 16.6613C5.12677 14.4496 5.12677 10.8637 7.33845 8.65194C9.55017 6.44022 13.1361 6.44022 15.3478 8.65194Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M19.0812 8.65203L19.4152 8.31805C21.2819 11.787 20.7506 16.2061 17.8218 19.1348C14.2437 22.7129 8.44284 22.7125 4.86507 19.1348C1.28733 15.557 1.287 9.75614 4.86507 6.17807C7.79381 3.24933 12.2129 2.71801 15.6818 4.58469L15.3479 4.91866L15.3482 8.6517L19.0812 8.65203Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M15.3485 8.65199L12.8281 11.1724L11.3438 12.6567"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0857 5.91419L21.8181 5.91515L19.081 8.65222L15.348 8.65189L15.3477 4.91886L18.0847 2.18178L18.0857 5.91419Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
